import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import CustomSelect from "../../../../helpers/ui/CustomSelect";

import apiResponse from "../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";
import CreateBloc from "../Create/Blocs/CreateBloc";
import Shimmer from "react-shimmer-effect";

class IndexView extends Component {
  updateBloc = new UpdateBloc();
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      employeeOptions: [],
      selectedEmployee: null,
      selectedEmployeeUuid: "",
      nip: "",
      nama: "",
      jabatan: "",
      polaKerjaOptions: [],
      selectedPolaKerja: null,
      isLoadingOptEmployee: true,
      mandatoryOptions: [
        {
          label: "Ya",
          value: 1,
        },
        {
          label: "Tidak",
          value: 0,
        },
      ],
      statusOptions: [
        {
          label: "Aktif",
          value: 1,
        },
        {
          label: "Tidak Aktif",
          value: 0,
        },
      ],
      listStopOptions: [],
      selectedType: null,
      test: [
        {
          label: "BUP NON KPP",
          value: "dd5059c0-e2c5-4baa-ae28-d50a3ff00429",
        },
      ],
      template: null,
      loadingDetail: false,
    };
  }

  reformatData = function (options) {
    var values = [];
    options.map(function (option) {
      values.push(option["value"]);
    });

    return values;
  };

  // handleSelectChange = (selectedOption) => {
  //   if (selectedOption) {
  //     const selectedValues = selectedOption.map((option) => option.value);
  //     this.setState({
  //       selectedType: selectedValues,
  //     });
  //   } else {
  //     this.setState({
  //       selectedType: null,
  //     });
  //   }

  handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      //console.log(selectedOption)
      let multi = [];
      selectedOption.forEach(function (row) {
        multi.push(row.value);
      });
      this.setState({
        selectedType: multi.join(),
        selectedTypeOption: selectedOption,
      });
    } else {
      this.setState({
        selectedType: "",
        selectedTypeOption: "",
      });
    }
  };

  submitData = async () => {
    const files = ["file-template"];
    const formData = generateFormData(this.state.dataForm, files);
    await this.updateBloc.fetchUpdate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.state.dataForm.signatories_official_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          // console.log();
          if (result.data.status === true) {
            console.log("buat");
            this.setState({
              loading: false,
              success: true,
            });
          } else {
            console.log("ada");
            this.setState({
              failedInfo: result.data.message,
              loading: false,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: result.data.message,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingDetail: true,
          });

        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            let multi = [];
            response.retired_doctype_type_name.forEach(function (row) {
              multi.push(row.value);
            });
            this.setState({
              dataForm: response,
              selectedTypeOption: response.retired_doctype_type_name,
              selectedType: multi.join(),
              template: response.document_template
                ? response.document_template.documents_path
                : null,
              loadingDetail: false,
            });
          }
          break;
        case apiResponse.ERROR:
          this.setState({
            loadingDetail: false,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.listStopChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              listStopOptions: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const queryParams = new URLSearchParams(this.props.location.search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });

    this.updateBloc.fetchTypeStop();
  }

  componentWillUnmount() {
    this.updateBloc.updateChannel?.unsubscribe();
    this.updateBloc.detailChannel?.unsubscribe();
    this.updateBloc.listStopChannel?.unsubscribe();
    // this.createBloc.createChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Edit Dokumen Pensiun</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                      name="uuid"
                      type="hidden"
                      id="uuid"
                      value={this.state.dataForm.retired_doctype_uuid}
                    />
                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_name"
                        className="col-md-2 col-form-label"
                      >
                        Nama Dokumen <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder="Nama Dokumen"
                          name="retired_doctype_name"
                          id="retired_doctype_name"
                          validate={{ required: { value: true } }}
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.retired_doctype_name}
                          errorMessage="Masukkan Nama Dokumen"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_tooltip"
                        className="col-md-2 col-form-label"
                      >
                        Tooltip <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <AvField
                          placeholder="Tooltip"
                          name="retired_doctype_tooltip"
                          id="retired_doctype_tooltip"
                          validate={{ required: { value: true } }}
                          type="textarea"
                          className="form-control"
                          value={this.state.dataForm?.retired_doctype_tooltip}
                          errorMessage="Masukkan Tooltip"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_type_uuid"
                        className="col-md-2 col-form-label"
                      >
                        Jenis <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <Select
                          options={this.state.listStopOptions}
                          value={this.state.selectedTypeOption}
                          name={"retired_doctype_type_uuid"}
                          placeholder={"Pilih Jenis Pemberhentian"}
                          className="form-control"
                          isSearchable={true}
                          onChange={this.handleSelectChange}
                          isMulti
                        />
                        <AvField
                          type="hidden"
                          name="retired_doctype_type_uuid"
                          value={this.state.selectedType}
                          validate={{ required: { value: true } }}
                          errorMessage="Pilih Jenis Pemberhentian"
                          //
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_is_required"
                        className="col-md-2 col-form-label"
                      >
                        Mandatory <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <CustomSelect
                          name={`retired_doctype_is_required`}
                          errorMessage="Pilih Mandatory"
                          options={this.state.mandatoryOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Mandatory"
                          defaultValue={
                            this.state.dataForm?.retired_doctype_is_required
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_sort"
                        className="col-md-2 col-form-label"
                      >
                        Nomor Urut <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          placeholder="Nomor Urut"
                          name="retired_doctype_sort"
                          id="retired_doctype_sort"
                          validate={{ required: { value: true } }}
                          type="number"
                          className="form-control"
                          value={this.state.dataForm?.retired_doctype_sort}
                          errorMessage="Masukkan Nomor Urut"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_doctype_status"
                        className="col-md-2 col-form-label"
                      >
                        Status <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <CustomSelect
                          name={`retired_doctype_status`}
                          errorMessage="Pilih Status"
                          options={this.state.statusOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Status"
                          defaultValue={
                            this.state.dataForm?.retired_doctype_status
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        File Template
                      </Label>
                      <Col md="6">
                        <FileInput name="file-template" col="2" />
                      </Col>
                      <Col md="3">
                        {this.state.loadingDetail === true ? (
                          <>
                            <Shimmer>
                              <div style={{ width: "30%", height: 15 }}></div>
                            </Shimmer>
                          </>
                        ) : this.state.template ? (
                          <>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-sm btn-primary"
                              href={this.state.template}
                            >
                              <i className="uil-file-download"></i> Download
                              File
                            </a>
                          </>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo={this.state.failedInfo} //"Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/master/dokumen_pensiun.html?" />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
